import type { DanceSeoHead } from "../danceSeoTypes.js";

// zh translation of shared/danceSeoHeads/en.ts; numbers and claims must stay in sync with the English source.
const head: DanceSeoHead = {
  director: {
    title: "AI 舞蹈视频生成器 - 用音乐生成舞蹈视频，免费开始",
    description:
      "把任何一首歌变成完整的 AI 舞蹈视频。Solmi 为每个段落规划编舞，为每个镜头制作分镜，并渲染舞蹈镜头和口型同步镜头。免费开始。",
    h1: "AI 舞蹈视频生成器 — 把任何一首歌变成舞蹈视频",
  },
  photo: {
    title: "让照片跳舞 - 用照片生成 AI 舞蹈 | Solmi",
    description:
      "用 AI 让照片跳舞：上传一张全身照，选择一个动作或上传自己的舞蹈片段，再添加一首歌。Solmi 让舞蹈踩准节拍。免费开始。",
    h1: "让照片跳舞 — 用照片生成 AI 舞蹈",
  },
  inbound:
    "想让表演者跳舞？[AI 舞蹈视频生成器](/ai-dance-video-generator)会为歌曲的每个段落规划编舞，并渲染一支完整的舞蹈视频。",
};

export default head;
